import React from 'react';

function Dropdown() {
  return (
    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.3293 7.10368L11.8643 1.55333C12.0455 1.37148 12.0452 1.07706 11.8634 0.895514C11.6815 0.714109 11.3869 0.714577 11.2055 0.896452L5.99998 6.11643L0.794438 0.896264C0.613032 0.714413 0.318635 0.713945 0.136761 0.895327C0.0455894 0.986334 3.8147e-06 1.10556 3.8147e-06 1.22479C3.8147e-06 1.34371 0.0452843 1.46247 0.135823 1.55331L5.67068 7.10368C5.75782 7.19127 5.87642 7.24042 5.99998 7.24042C6.12354 7.24042 6.24199 7.19113 6.3293 7.10368Z"
      />
    </svg>
  );
}

export default Dropdown;
